import React from 'react'
import { NavLink } from 'react-router-dom'
import { SOCIAL_LINKS } from '../siteConfig'

// The nav strip. On desktop it carries the links and the social icons; below
// 992px it collapses to nothing and only expands to show the panel that the
// header's menu button opens. Open state and sticky state are owned by Header.
const NAV_ITEMS = [
    { to: '/', label: 'Home', exact: true },
    { to: '/about', label: 'About Garima' },
    { to: '/programs', label: 'Programs' },
    { to: '/contact', label: 'Contact Us' },
];

function Menu({ menuOpen, sticky, onNavigate }) {
    return (
        <div className={`header-bottom stricky${sticky ? ' stricky-fixed' : ''}`}>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="inner-content clearfix">
                            <div className="header-bottom-left clearfix float-left">
                                <nav className="main-menu clearfix">
                                    <div
                                        id="main-navigation"
                                        className={`navbar-collapse collapse clearfix${menuOpen ? ' show in' : ''}`}
                                    >
                                        <ul className="navigation clearfix">
                                            {NAV_ITEMS.map((item) => (
                                                <li key={item.to}>
                                                    <NavLink
                                                        exact={item.exact}
                                                        to={item.to}
                                                        activeClassName="current"
                                                        onClick={onNavigate}
                                                    >
                                                        {item.label}
                                                    </NavLink>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </nav>
                            </div>
                            <div className="header-bottom-right float-right">
                                <span>Stay Connected:</span>
                                <ul className="header-social-links">
                                    {SOCIAL_LINKS.map((link) => (
                                        <li key={link.key}>
                                            <a href={link.href} target="_blank" rel="noopener noreferrer" aria-label={link.label}>
                                                <i className={`fa ${link.icon}`} aria-hidden="true"></i>
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Menu
